import { AspectRatio } from "@/components/ui/aspect-ratio";

interface ButtonData {
  text: string;
  url: string;
  variant: "primary" | "outline";
}

interface BannerSectionProps {
  imageUrl?: string;
  buttons?: ButtonData[];
  backgroundColor?: string;
  onButtonClick?: (url: string, text: string) => void;
}

export function BannerSection({ imageUrl, buttons = [], backgroundColor, onButtonClick }: BannerSectionProps) {
  const linkUrl = buttons?.[0]?.url;

  if (!imageUrl) return null;

  const imageElement = (
    <AspectRatio ratio={2 / 1}>
      <img
        src={imageUrl}
        alt="Banner do parceiro"
        className="w-full h-full object-cover rounded-lg"
        loading="eager"
      />
    </AspectRatio>
  );

  return (
    <section
      className="w-full py-6 px-4 flex justify-center"
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      <div className="w-full max-w-[800px] rounded-lg shadow-md overflow-hidden">
        {linkUrl ? (
          <a href={linkUrl} target="_blank" rel="noopener noreferrer" className="block" onClick={() => onButtonClick?.(linkUrl, buttons?.[0]?.text || "Banner")}>
            {imageElement}
          </a>
        ) : (
          imageElement
        )}
      </div>
    </section>
  );
}
